import { combineReducers } from 'redux';

import { tagReducer } from './tags/store/tag.reducer';

export const adminReducer = combineReducers({
    tag: tagReducer,
});
